
import React from 'react'
import styled from 'styled-components'

const DateSeparator = ({ date }) => {

    return (
        <Container>
            <Line />
            <DateSeparatorWrapper>
                <p>{(date)}</p>
            </DateSeparatorWrapper>
            <Line />
        </Container>
    )
}

export default DateSeparator
const Container = styled.div`
display:flex;
width:100%;
align-items:center;
justify-content:center;
padding:10px 0;
`
const DateSeparatorWrapper = styled.div`

display:flex;
justify-content:center;
align-items:center;
width:fit-content;
p{
width:fit-content;
font-size: 14px;
font-weight: 500;
line-height: 17px;
white-space:nowrap;
color:${({ theme }) => theme.chat.dateSeparatorColor};
}

`
const Line = styled.div`
display:flex;
width:100%;
min-height:1px;
background:${({ theme }) => theme.chat.dateSeparatorLine};
margin:0 20px;
`